export default __webpack_public_path__ + "static/media/play_button.4bb70db6.svg";